// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FYVhD","colMin":"styles_colMin__QG6Xr"};